import * as THREE from 'three';
import { getNumNodesLoading, getMaxNodesLoading } from '../config.service';

export class OctreeGeometry {
  url: string | null = null;
  spacing = 0;
  boundingBox: THREE.Box3 | null = null;
  root: OctreeGeometryNode | null = null;
  pointAttributes: any = null;
  loader: any = null;
  scale: number | undefined;
  projection: string | undefined;
  tightBoundingBox: THREE.Box3 | undefined;
  boundingSphere: THREE.Sphere | undefined;
  tightBoundingSphere: THREE.Sphere | undefined;
  offset: THREE.Vector3 | undefined;
}

let idCount = 0;

export class OctreeGeometryNode {
  id: number;
  name: string;
  index: number;
  octreeGeometry: OctreeGeometry;
  boundingBox: THREE.Box3;
  boundingSphere: THREE.Sphere;
  children: Record<number, OctreeGeometryNode | undefined> = {};
  numPoints = 0;
  level: number | null = null;
  oneTimeDisposeHandlers: (() => void)[] = [];
  loaded = false;
  loading = false;
  parent: OctreeGeometryNode | undefined;
  spacing: number | undefined;
  geometry: THREE.BufferGeometry | null | undefined;
  nodeType: number | undefined;
  hierarchyByteOffset: bigint | undefined;
  hierarchyByteSize: bigint | undefined;
  byteOffset: bigint | number | undefined;
  byteSize: bigint | undefined;
  hasChildren: boolean | undefined;
  density: number | undefined;

  constructor(name: string, octreeGeometry: OctreeGeometry, boundingBox: THREE.Box3) {
    this.id = idCount++;
    this.name = name;
    this.index = parseInt(name.charAt(name.length - 1));
    this.octreeGeometry = octreeGeometry;
    this.boundingBox = boundingBox;
    this.boundingSphere = boundingBox.getBoundingSphere(new THREE.Sphere());
  }

  isGeometryNode(): boolean {
    return true;
  }

  getLevel(): number | null {
    return this.level;
  }

  isTreeNode(): boolean {
    return false;
  }

  isLoaded(): boolean {
    return this.loaded;
  }

  getBoundingSphere(): THREE.Sphere {
    return this.boundingSphere;
  }

  getBoundingBox(): THREE.Box3 {
    return this.boundingBox;
  }

  getChildren(): OctreeGeometryNode[] {
    const children: OctreeGeometryNode[] = [];
    for (let i = 0; i < 8; i++) {
      if (this.children[i]) {
        children.push(this.children[i]!);
      }
    }
    return children;
  }

  load(): void {
    if (getNumNodesLoading() >= getMaxNodesLoading()) {
      return;
    }
    this.octreeGeometry.loader.load(this);
  }

  getNumPoints(): number {
    return this.numPoints;
  }

  dispose(): void {
    if (this.geometry && this.parent != null) {
      this.geometry.dispose();
      this.geometry = null;
      this.loaded = false;

      for (const handler of this.oneTimeDisposeHandlers) {
        handler();
      }
      this.oneTimeDisposeHandlers = [];
    }
  }
}
